module.exports = __webpack_public_path__ + "static/img/fish51.f7b25c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish51.png
// module id = UBfS
// module chunks = 0